/**
 * @module Component
 * @description
 */
import React, { FC } from 'react';
import { Container } from '../Grid';
import ConditionalWrapper from '../ConditionalWrapper';
import styles from './index.module.css';

// cohesion
import { MonarchSlot } from '@redventures/cohesion-utils-react';



interface Props {
  children: JSX.Element;
  className?: string;
  inContainer?: boolean;
  containerClass?: string;
  placement?: string;
  style?: object;
}

const Component: FC<Props> = ( {
  children,
  className = '',
  inContainer = false,
  containerClass = '',
  placement = '',
  style,
  ...props
} ) => (
  <ConditionalWrapper
    condition={ placement !== '' }
    wrapper={ ( children: JSX.Element ) => <MonarchSlot slotId={ placement }>
      { children }
    </MonarchSlot> }
    children={
      <section className={ `${ styles.component } ${ className }` } style={ style } { ...props }>
        <ConditionalWrapper
          condition={ inContainer }
          wrapper={ ( children: JSX.Element ) => <Container className={ containerClass }>{ children }</Container> }
        >
            { children }
        </ConditionalWrapper>
      </section>
    }
  />
);

Component.displayName = 'Component';

export default Component;
